// Copyright (c) 2018 Deere & Company

import ActionsPopoverCallback from '../../../state/actions-popover-callback';

const createCallBack = (label, onOptionClick, onOptionClickValues) =>
    new ActionsPopoverCallback({
        label,
        onOptionClick,
        onOptionClickValues
    });

export const getOptions = (onCreateLayoutCallback, onEditLayoutCallback, selectedLayoutName) => {

    const options = [];

    if (selectedLayoutName) {

        options.push(createCallBack('EDIT_LAYOUT', onEditLayoutCallback));

    }

    options.push(createCallBack('CREATE_LAYOUT', onCreateLayoutCallback));

    return options;

};



// WEBPACK FOOTER //
// ./src/shared/components/excel-layout/services/get-options.js